import { api } from '@/utils/api'
import { MemberExtended } from '@/types'
import { useInfiniteLoading } from './useInfiniteLoading'

const fetchTeamMembers = async (
  { pageParam }: { pageParam: number },
  teamId: string
) => {
  const resp = await api.get(`/teams/${teamId}/members`, {
    params: { page: pageParam },
  })
  return {
    data: resp.data.data ?? [],
    totalCount: resp.data.totalCount ?? 0,
  }
}

export const useTeamMembers = (teamId?: string) => {
  return useInfiniteLoading<MemberExtended>({
    enabled: !!teamId,
    queryKey: ['team-members', teamId],
    queryFn: (p) => fetchTeamMembers(p, teamId!),
  })
}
